import { render, staticRenderFns } from "./main-media.vue?vue&type=template&id=ea937450&scoped=true&"
import script from "./main-media.vue?vue&type=script&lang=js&"
export * from "./main-media.vue?vue&type=script&lang=js&"
import style0 from "./main-media.vue?vue&type=style&index=0&id=ea937450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea937450",
  null
  
)

export default component.exports